"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mainViewController_1 = require("../mainViewController");
var adFormatController_1 = require("./adFormatController");
var discountController_1 = require("./discountController");
var stringHelper_1 = require("./stringHelper");
var RowResponseMerger = (function () {
    function RowResponseMerger() {
    }
    RowResponseMerger.mergeSingleRowWithResponse = function (row, placementResult, analysis, treeManager, correspondingMultiplierData) {
        var clone = _.assign({}, row);
        RowResponseMerger.fixPotential(clone, placementResult.online);
        RowResponseMerger.setBasicResultDataToClone(clone, placementResult);
        if (placementResult.result.error) {
            clone["rowState"] = mainViewController_1.rowState.Error;
        }
        else {
            if (placementResult.online) {
                RowResponseMerger.setOnlineDataToClone(clone, placementResult);
            }
            clone = RowResponseMerger.mergeResponseResult(clone, placementResult);
            if (correspondingMultiplierData) {
                RowResponseMerger.mergeMultiplierDataToRow(clone, correspondingMultiplierData);
                RowResponseMerger.calcMultiplierDataPercent(clone, correspondingMultiplierData, clone["audienceContacts"]);
            }
            var periodPrettyName = _.findWhere(analysis.periods, { "key": clone["medium"].period });
            if (periodPrettyName) {
                if (periodPrettyName.key === "KZ") {
                    clone["frequencyCappingValidFor"] = "Zeitraum";
                }
                else {
                    var shortPeriodPrettyName = stringHelper_1.StringHelper.shortenPeriodDescription(periodPrettyName["description"]);
                    clone["frequencyCappingValidFor"] = clone["frequency"] + " " +
                        stringHelper_1.StringHelper.removeAverageSymbol(stringHelper_1.StringHelper.pluralize(shortPeriodPrettyName, clone["frequency"]));
                    if (_.get(clone, "additionalData.frequencyCappingForTotal")) {
                        if (!clone["frequencyCapping"]) {
                            clone["frequencyCapping"] = {};
                        }
                        if (clone["frequencyCapping"].impressions !== 0) {
                            clone["frequencyCappingValidFor"] = "pro " + stringHelper_1.StringHelper.removeAverageSymbol(shortPeriodPrettyName);
                        }
                        else {
                            clone["frequencyCapping"].forTotal = false;
                        }
                    }
                }
            }
            clone["rowState"] = RowResponseMerger.piHigherThanMaxAdContactsAdformat(clone) ? mainViewController_1.rowState.Warning : mainViewController_1.rowState.OK;
            if (_.get(clone, "additionalData.specialPriceData.specialCpmAmount")) {
                _.set(clone, "additionalData.calculationTypeName", "Spezial-TKP");
            }
            else if (_.get(placementResult, "result.tariff.fixedPrice")) {
                _.set(clone, "additionalData.calculationTypeName", "Festpreis");
            }
            else if (_.get(placementResult, "result.tariff.pricing")) {
                var price = _.get(placementResult, "result.tariff.pricing") === "FixPrice" ? "Festpreis" : "TKP-Berechn.";
                clone["conditions"]["online"]["calculationTypeName"] = _.get(placementResult, "result.tariff.pricing");
                _.set(clone, "additionalData.calculationTypeName", price);
            }
            else {
                _.set(clone, "additionalData.calculationTypeName", "TKP-Berechn.");
            }
        }
        clone["targeting"]["keys"]["informationHandler"] = RowResponseMerger.generateTargetingHandler(clone);
        if (_.get(clone, "targeting.keys.keys") && treeManager !== undefined) {
            clone["targeting"]["keys"]["shortDescription"] =
                treeManager.getShortDescriptions(_.get(clone, "targeting.keys.keys")) || "Kein";
        }
        RowResponseMerger.setSpecialDiscountsInRow(placementResult, clone);
        discountController_1.DiscountController.updateSpecialDiscounts(_.get(clone, "specialDiscounts"), _.get(clone, "conditions"));
        RowResponseMerger.handleMissed67(placementResult, clone);
        return clone;
    };
    RowResponseMerger.setBasicResultDataToClone = function (clone, placementResult) {
        var online = placementResult.online;
        clone["piMax"] = _.get(online, "piMax");
        clone["cpm"] = _.get(online, "basisCpm.amount");
        clone["base_tkp"] = _.get(online, "rateCardCpm.amount");
        if (_.get(online, "targetingExtraCpm")) {
            clone["targetingExtraCpm"] = online.targetingExtraCpm;
        }
    };
    RowResponseMerger.setOnlineDataToClone = function (clone, placementResult) {
        var online = placementResult.online;
        clone["share"] = _.get(online, "eventualShare");
        clone["pi"] = _.get(online, "pi");
        clone["contacts_total"] = placementResult.frequency * online.pi;
        if (clone["additionalData"] === undefined || clone["additionalData"]["specialCpmAmount"] === undefined) {
            if (placementResult.result.tariff && placementResult.result.tariff.gross) {
                var cpm = placementResult.result.cpm;
                var baseCpm = online.basisCpm;
                var fcExtra = online.fcExtraCpm;
                var targetingExtra = online.targetingExtraCpm;
                var totalCpm = online.totalCpm;
                if (baseCpm) {
                    if (targetingExtra) {
                        clone["targetingCost"] = {
                            absolute: targetingExtra.amount,
                            percent: RowResponseMerger.calcPercent(baseCpm.amount, targetingExtra.amount)
                        };
                    }
                    if (fcExtra) {
                        clone["frequencyCappingCost"] = {
                            absolute: fcExtra.amount,
                            percent: RowResponseMerger.calcPercent(baseCpm.amount, fcExtra.amount)
                        };
                    }
                    clone["baseCpm"] = baseCpm.amount;
                }
                if (totalCpm) {
                    clone["cpmTotal"] = totalCpm.amount;
                }
                clone["additionalData.specialCpmAmount"] = cpm;
            }
        }
    };
    RowResponseMerger.fixPotential = function (clone, online) {
        var adFormat = adFormatController_1.AdFormatController.getAdFormat(clone);
        if (online && adFormat) {
            var thePotential = adFormat.potential;
            if (thePotential === -1) {
                thePotential = 1;
            }
            clone["maxContactsAdformat"] = online.piMax * thePotential;
        }
    };
    RowResponseMerger.handleMissed67 = function (placementResult, clone) {
        if (placementResult.status === "missed_6/7") {
            clone["rowState"] = mainViewController_1.rowState.ErrorMissed67;
        }
    };
    RowResponseMerger.setSpecialDiscountsInRow = function (placementResult, clone) {
        var tariff = _.get(placementResult, "result.tariff");
        var amount1 = _.get(tariff, "afterSpecialDiscount1.amount");
        var amount2 = _.get(tariff, "afterSpecialDiscount2.amount");
        var amount3 = _.get(tariff, "afterSpecialDiscount3.amount");
        var amount4 = _.get(tariff, "afterSpecialDiscount4.amount");
        var amount5 = _.get(tariff, "afterSpecialDiscount5.amount");
        var amountAE = _.get(tariff, "afterAgencyCommission.amount");
        var amountCashDiscount = _.get(tariff, "afterCashDiscount.amount");
        var amountVat = _.get(tariff, "net.amount");
        _.set(clone, "specialDiscounts.absolute1", amount1);
        _.set(clone, "specialDiscounts.absolute2", amount2);
        _.set(clone, "specialDiscounts.absolute3", amount3);
        _.set(clone, "specialDiscounts.absolute4", amount4);
        _.set(clone, "specialDiscounts.absolute5", amount5);
        _.set(clone, "specialDiscounts.absoluteAE", amountAE);
        _.set(clone, "specialDiscounts.absoluteCashDiscount", amountCashDiscount);
        _.set(clone, "specialDiscounts.net", amountVat);
    };
    RowResponseMerger.mergeMultiplierDataToRow = function (row, correspondingMultiplierData) {
        correspondingMultiplierData.forEach(function (correspondingItem) {
            _.set(row, correspondingItem.plan.toString(), correspondingItem.value);
        });
    };
    RowResponseMerger.calcMultiplierDataPercent = function (row, correspondingMultiplierData, base) {
        correspondingMultiplierData.forEach(function (correspondingItem) {
            var value = correspondingItem.value;
            var percent = RowResponseMerger.calcPercent(base, value);
            _.set(row, correspondingItem.plan.toString() + "_percent", percent);
        });
    };
    RowResponseMerger.calcPercent = function (base, value) {
        if (value === undefined) {
            return undefined;
        }
        if (base === 0) {
            return 0;
        }
        var percentage = 100;
        return (value / base) * percentage;
    };
    RowResponseMerger.piHigherThanMaxAdContactsAdformat = function (row) {
        return (row["pi"] <= row["contacts_total"] && row["pi"] > row["maxContactsAdformat"]);
    };
    RowResponseMerger.generateTargetingHandler = function (row) {
        return function () {
            var data = {
                cpmAmount: row["additionalData.specialCpmAmount"],
                frequencyCapping: row["frequencyCappingCost"],
                targetingCost: row["targetingExtraCpm"],
                cpm: row["cpm"],
                gross: row["gross"],
                baseCpm: row["baseCpm"],
                totalCpm: row["cpmTotal"],
                targetingCpm: row["targetingCost"],
                fcCpm: row["frequencyCappingCost"]
            };
            return data;
        };
    };
    RowResponseMerger.mergeResponseResult = function (orig, placement) {
        var clone = _.assign({}, orig);
        var result = placement.result;
        if (!result.error) {
            clone["audienceContacts"] = result.contacts;
            clone["uu_percent"] = result.percent;
            clone["user_share"] = result.share;
            clone["targeting_million"] = result.projection;
            clone["grp"] = result.grp;
            clone["average_contacts"] = result.ots;
            clone["projection"] = result.projection;
            clone["cases"] = result.cases;
            clone["cpmGross"] = _.get(result, "cpmGross.amount");
            clone["cpmNet"] = _.get(result, "cpmNet.amount");
            clone["affinityIndex"] = result.index;
            var online = placement.online;
            if (online) {
                clone["cpm"] = _.get(online, "basisCpm.amount");
                clone["targetingSummary"] = online.targetingSummaryShort;
            }
            clone["gross"] = _.get(result, "tariff.gross.amount");
            if (_.get(result, "tariff.status") === "TarifStatus_IsFix") {
                clone["gross"] = _.get(result, "tariff.fixedPrice.amount");
            }
            clone["nettoAfterPriceListGross"] = _.get(result, "tariff.net.amount");
        }
        return clone;
    };
    return RowResponseMerger;
}());
exports.RowResponseMerger = RowResponseMerger;
//# sourceMappingURL=RowResponseMerger.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/RowResponseMerger.js
// module id = 68
// module chunks = 0